import store from '../store/store'
import axios from 'axios'
import serviceHelpers from './serviceHelpers'
import subscriptionHelpers from './subscriptionHelpers'

function updateUserObject (user) {
  if (user && user.tel && user.email) {
    const value = {
      'uuid': `${user.id}`,
      'gdpr_optin': true,
      'phone_number': user.tel,
      'email': user.email,
      'custom': {
        'remaining_service_hours': 0,
        'total_bookings': 0
      }
    }
    if (store.state && store.state.user) {
      value.custom.remaining_service_hours = store.state.user.remainingServiceHours
      value.custom.total_bookings = store.state.user.totalBookings
    }
    window.InsiderQueue.push({
      type: 'user',
      value: value
    })
  }
}

export default {
  homePageViewEvent (user) {
    try {
      // home and checkout page view
      window.InsiderQueue = []
      window.InsiderQueue.push({ type: 'home' })
      if (user) {
        updateUserObject(user)
      }
      window.InsiderQueue.push({ type: 'init' })
      if (window.Insider) {
        window.Insider.eventManager.dispatch('init-manager:re-initialize')
      }
      // console.log('check insider home page view', window.InsiderQueue)
    } catch (error) {
      console.log('insider page view error', error.message)
    }
  },
  categoryPageViewEvent (user, categories) {
    try {
      window.InsiderQueue = []
      window.InsiderQueue.push({
        type: 'category',
        value: categories
      })
      if (user) {
        updateUserObject(user)
      }
      window.InsiderQueue.push({
        type: 'init'
      })
      window.Insider.eventManager.dispatch('init-manager:re-initialize')
      // console.log('check insider category page view', window.InsiderQueue)
    } catch (error) {
      console.log('insider category page view error', error.message)
    }
  },
  productViewEvent (params) {
    try {
      const user = params.user
      const serviceId = params.serviceId
      const provinceId = params.provinceId
      const totalPrice = params.totalPrice
      const bookingCountType = params.bookingCountType
      const isNoDateTimeBooking = params.isNoDateTimeBooking

      // Find parentService
      const service = store.state.globalVal.services[serviceId]
      const parentService = serviceHelpers.getParentService(store.state.globalVal.services, serviceId)
      const serviceName = (service.parent_id) ? `${parentService.name_th} - ${service.name_th}` : service.name_th
      let url = `https://beneat.co/booking/start?sid=${parentService.id}`
      if (params.experienceId) {
        url = `https://beneat.co/special-services/${params.experienceId}`
      } else if (params.professionalId) {
        url = `https://beneat.co/cleaner/${params.professionalId}`
      }
      window.InsiderQueue = []
      window.InsiderQueue.push({
        type: 'product',
        value: {
          'id': `${parentService.id}`,
          'name': serviceName,
          'taxonomy': [
            'Services',
            'Fixed Rate Services',
            parentService.name_en
          ],
          'unit_price': totalPrice,
          'unit_sale_price': totalPrice,
          'url': url,
          'product_image_url': parentService.picture,
          'custom': {
            'province_id': `${provinceId}`,
            'bookingCountType': bookingCountType,
            'isNoDateTimeBooking': isNoDateTimeBooking
          }
        }
      })
      if (user) {
        updateUserObject(user)
      }
      window.InsiderQueue.push({
        type: 'currency',
        value: 'THB'
      })
      window.InsiderQueue.push({
        type: 'init'
      })
      window.Insider.eventManager.dispatch('init-manager:re-initialize')
      // console.log('check insider product page view', window.InsiderQueue)
    } catch (error) {
      console.log('insider product event error', error.message)
    }
  },
  cartViewEvent (params) {
    try {
      const globalVal = store.state.globalVal
      const user = params.user
      const preBookingData = params.preBookingData
      const totalPrice = params.totalPrice
      const service = globalVal.services[preBookingData.service_id]
      const parentService = serviceHelpers.getParentService(globalVal.services, preBookingData.service_id)
      const serviceName = (service.parent_id) ? `${parentService.name_th} - ${service.name_th}` : service.name_th
      const provinceId = preBookingData.province_id
      const bookingCountType = (!preBookingData.subscription_type_id && !preBookingData.package_type) ? 'one_time' : 'multiple_times'
      let isNoDateTimeBooking = false
      if ((!preBookingData.cleaning_date && !preBookingData.cleaning_time && !preBookingData.package_type) || (preBookingData.package_type && !preBookingData.multi_dates_times.length)) {
        isNoDateTimeBooking = true
      }
      // Check booking quantity
      let orderQty = 1
      const subscriptionTypeId = preBookingData.subscription_type_id
      const packageType = preBookingData.package_type
      const packageTypeDiscount = preBookingData.package_type_discount
      if (subscriptionTypeId) {
        const subscriptionType = subscriptionHelpers.getSubscriptionTypeData(globalVal.subscriptionTypes, subscriptionTypeId)
        orderQty = subscriptionType.num_per_month
      } else if (packageType) {
        if (packageType.category === 'unlimited') {
          orderQty = preBookingData.multi_dates_times.length
        } else if (packageType.category === 'flexible') {
          orderQty = packageTypeDiscount.booking_qty
        }
      }
      // Prepare item for cart product item
      const item = {
        'id': `${parentService.id}`,
        'name': serviceName,
        'taxonomy': [
          'Services',
          'Fixed Rate Services',
          service.name_en
        ],
        'unit_price': totalPrice,
        'unit_sale_price': totalPrice,
        'quantity': orderQty,
        'url': `https://beneat.co/booking/start?sid=${parentService.id}`,
        'product_image_url': service.picture,
        'custom': {
          'province_id': `${provinceId}`,
          'bookingCountType': bookingCountType,
          'isNoDateTimeBooking': isNoDateTimeBooking
        }
      }
      // Add to cart event
      window.InsiderQueue = []
      window.InsiderQueue.push({
        type: 'currency',
        value: 'THB'
      })
      window.InsiderQueue.push({
        type: 'add_to_cart',
        value: item
      })
      // console.log('check insider add_to_cart event', window.InsiderQueue)
      window.Insider.eventManager.dispatch('init-manager:re-initialize')
      setTimeout(() => {
        // Cart view event
        window.InsiderQueue = []
        window.InsiderQueue.push({
          type: 'cart',
          value: {
            'total': totalPrice,
            'items': [item]
          }
        })
        updateUserObject(user)
        window.InsiderQueue.push({
          type: 'currency',
          value: 'THB'
        })
        window.InsiderQueue.push({
          type: 'init'
        })
        window.Insider.eventManager.dispatch('init-manager:re-initialize')
        // console.log('check insider cart page view', window.InsiderQueue)
      }, 500)
    } catch (error) {
      console.log('insider cart event error', error.message)
    }
  },
  async purchaseEvent (params) {
    try {
      const user = params.user
      const orderId = params.orderId
      const orderQty = params.orderQty ? params.orderQty : 1
      const url = `/orders/${orderId}`
      const { data } = await axios.get(url)
      if (data && !data.error) {
        const service = store.state.globalVal.services[data.service_id]
        const parentService = serviceHelpers.getParentService(store.state.globalVal.services, data.service_id)
        const serviceName = (service.parent_id) ? `${parentService.name_th} - ${service.name_th}` : service.name_th
        const totalPriceWithVat = Number(data.total_price_with_vat)
        const bookingCountType = (!data.subscription_id && !data.package_id) ? 'one_time' : 'multiple_times'
        const isNoDateTimeBooking = (data.is_no_datetime_booking === 1)
        window.InsiderQueue = []
        window.InsiderQueue.push({
          type: 'purchase',
          value: {
            'order_id': `${orderId}`,
            'total': totalPriceWithVat,
            'items': [
              {
                'id': `${parentService.id}`,
                'name': serviceName,
                'taxonomy': [
                  'Services',
                  'Fixed Rate Services',
                  parentService.name_en
                ],
                'unit_price': totalPriceWithVat,
                'unit_sale_price': totalPriceWithVat,
                'url': `https://beneat.co/booking/start?sid=${parentService.id}`,
                'product_image_url': parentService.picture,
                'quantity': orderQty,
                'custom': {
                  'province_id': `${data.province_id}`,
                  'bookingCountType': bookingCountType,
                  'isNoDateTimeBooking': isNoDateTimeBooking
                }
              }
            ]
          }
        })
        updateUserObject(user)
        window.InsiderQueue.push({
          type: 'currency',
          value: 'THB'
        })
        window.InsiderQueue.push({
          type: 'init'
        })
        window.Insider.eventManager.dispatch('init-manager:re-initialize')
        // console.log('check insider purchase event', window.InsiderQueue)
      }
    } catch (error) {
      console.log('insider purchase event error', error.message)
    }
  },
  specialServicePageViewEvent (user, experienceId) {
    try {
      window.InsiderQueue = []
      window.InsiderQueue.push({
        type: 'custom_event',
        value: [{
          event_name: 'view_special_service_detail',
          event_parameters: {
            custom: {
              special_service_id: experienceId
            }
          }
        }]
      })
      if (user) {
        updateUserObject(user)
      }
      window.InsiderQueue.push({
        type: 'init'
      })
      window.Insider.eventManager.dispatch('init-manager:re-initialize')
      // console.log('check insider special service page view', window.InsiderQueue)
    } catch (error) {
      console.log('insider special service page view error', error.message)
    }
  },
  serviceRequestPageViewEvent (user, serviceId) {
    try {
      window.InsiderQueue = []
      window.InsiderQueue.push({
        type: 'custom_event',
        value: [{
          event_name: 'view_service_request',
          event_parameters: {
            custom: {
              service_id: serviceId
            }
          }
        }]
      })
      if (user) {
        updateUserObject(user)
      }
      window.InsiderQueue.push({
        type: 'init'
      })
      window.Insider.eventManager.dispatch('init-manager:re-initialize')
      // console.log('check insider service request page view', window.InsiderQueue)
    } catch (error) {
      console.log('insider service request page view error', error.message)
    }
  },
  submitServiceRequestEvent (user, params) {
    try {
      window.InsiderQueue = []
      window.InsiderQueue.push({
        type: 'custom_event',
        value: [{
          event_name: 'submit_service_request',
          event_parameters: {
            custom: {
              service_id: params.serviceId,
              service_request_purpose_id: params.serviceRequestPurposeId,
              service_date: params.serviceDate,
              service_time: params.serviceTime,
              building_type_id: params.buildingTypeId,
              building_size: params.buildingSize,
              customer_name: params.customerName,
              customer_phone: params.customerPhone,
              customer_address: params.customerAddress
            }
          }
        }]
      })
      updateUserObject(user)
      window.InsiderQueue.push({
        type: 'init'
      })
      window.Insider.eventManager.dispatch('init-manager:re-initialize')
      // console.log('check insider submit service request event', window.InsiderQueue)
    } catch (error) {
      console.log('insider submit service request error', error.message)
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/insiderHelpers.js